
import { Component, Vue, Watch } from 'vue-property-decorator';
import isImageSizeValid from '@/util/is-image-size-valid';
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
import { UPLOAD_DIR } from '@/constants';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  style: `${FCAPI}/boss/ruan/cases`,
  style_list: `${FCAPI}/boss/ruan/style/name`,
};
@Component({
  components: {
    SingleImageUpload,
    MultipleImageUpload,
  },
})
export default class RuanStyleDetail extends Vue {
  is_loading = false;
  UPLOAD_DIR = UPLOAD_DIR;
  is_new = false;
  form_item_layout = {
    labelCol: { span: 2 },
    wrapperCol: { span: 22 },
  };
  form: any = {
    name: {
      number: 12,
    },
    tag_list: [],
    style: {
      data: '',
    },
    list_image: {
      data: '',
    },
    detail_image: {
      data: [],
    },
  };
  tag_visible = false;
  style_list = [];
  tag_text = '';
  preview_image = '';
  preview_visible = false;
  send_data = {};

  get id(): number {
    const id = Number(this.$route.params.id);
    if (Number.isNaN(id)) {
      return 0;
    }
    return id;
  }
  get isNew() {
    return this.id === 0;
  }

  @Watch('form.list_image.data')
  onChangeListImg() {
    this.checkChange('list_image');
  }

  @Watch('form.detail_image.data')
  onChangeDetailImg() {
    this.checkChange('detail_image');
  }

  handleClose(item: string) {
    const tag_list = this.form.tag_list.filter((tag: any) => tag !== item);
    this.form.tag_list = tag_list;
  }

  onChangeTag(e: any) {
    this.tag_text = e.target.value;
  }

  addTag() {
    const tag_text = this.tag_text;
    if (tag_text && (this.form.tag_list as any).indexOf(tag_text) === -1) {
      (this.form.tag_list as any) = [...this.form.tag_list, tag_text];
    }
    Object.assign(this, {
      tag_visible: false,
      tag_text: '',
    });
  }

  showAddTagInput() {
    this.tag_visible = true;
    this.$nextTick(() => {
      (this.$refs.input as any).focus();
    });
  }

  handlePreview(imageUrl: string) {
    this.preview_image = imageUrl;
    this.preview_visible = true;
  }

  handlePreviewCancel() {
    this.preview_visible = false;
  }

  beforeListImgUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(
      file,
      (width: number, height: number) => width === 506 && height === 236
    ).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(
        `图片宽高限定 506*236px，当前上传图片宽高为 ${width}*${height}`
      );
      return Promise.reject(null);
    });
  }

  checkChange(field: any) {
    let error = '0';
    if (field === 'name') {
      if (!this.form.name.data) {
        this.form.name.status = 'error';
        this.form.name.error = '请输入案例名称';
        error = '1';
      } else {
        this.form.name.status = '';
        this.form.name.error = '';
      }
      if (this.form.name.data) {
        this.form.name.number =
          this.form.name.data.length > 12 ? 0 : 12 - this.form.name.data.length;
        if (this.form.name.data.length > 12) {
          this.form.name.status = 'error';
          this.form.name.error = '套餐名称最多12个字';
          error = '1';
        } else {
          this.form.name.status = '';
          this.form.name.error = '';
        }
      } else {
        this.form.name.number = 12;
      }
      return error;
    } else if (field === 'style') {
      if (!this.form.style.data) {
        this.form.style.status = 'error';
        this.form.style.error = '请选择所属风格';
        error = '1';
      } else {
        this.form.style.status = '';
        this.form.style.error = '';
      }
      return error;
    } else if (field === 'list_image') {
      if (!this.form.list_image.data) {
        this.form.list_image.status = 'error';
        this.form.list_image.error = '请上传列表图';
        error = '1';
      } else {
        this.form.list_image.status = '';
        this.form.list_image.error = '';
      }
      return error;
    } else if (field === 'detail_image') {
      if (this.form.detail_image.data.length <= 0) {
        this.form.detail_image.status = 'error';
        this.form.detail_image.error = '请上传详情图';
        error = '1';
      } else {
        this.form.detail_image.status = '';
        this.form.detail_image.error = '';
      }
      return error;
    }
    return error;
  }

  validator() {
    let is_valid = true;
    const valid = [];
    for (const key in this.form) {
      if (key) {
        valid.push(this.checkChange(key));
      }
    }
    this.$forceUpdate();
    if (valid.indexOf('1') !== -1) {
      is_valid = false;
    }
    return is_valid;
  }

  sendData() {
    const form = this.form;
    const send_data = {
      name: form.name.data,
      tag: form.tag_list.length > 0 ? form.tag_list.join(',') : '',
      style_id: form.style.data,
      list_image: form.list_image.data,
      detail_image: form.detail_image.data.join(','),
    };
    this.send_data = send_data;
  }

  submit() {
    if (!this.validator()) {
      return;
    }
    if (this.isNew) {
      this.add();
    } else {
      this.edit();
    }
  }

  async add() {
    this.sendData();
    const res = await this.$axios.post(API.style, this.send_data);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('新增成功');
    this.$router.push({
      path: '/ruan/style-list',
    });
  }

  async edit() {
    this.sendData();
    const res = await this.$axios.put(
      `${API.style}/${this.id}`,
      this.send_data
    );
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('编辑成功');
    this.$router.push({
      path: '/ruan/style-list',
    });
  }

  async query() {
    const res = await this.$axios.get(`${API.style}/${this.id}`);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    const form = this.form;
    form.name.data = data.name;
    form.tag_list = data.tag.split(',');
    form.style.data = data.style_id;
    form.list_image.data = data.list_image;
    form.detail_image.data = data.detail_image
      ? data.detail_image.split(',')
      : [];
  }

  async getStyleData() {
    const res = await this.$axios.get(API.style_list);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.style_list = data;
  }

  async created() {
    await this.getStyleData();
    if (!this.isNew) {
      await this.query();
    }
  }
}
